import { Component, inject, Input } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { GenericDialogData } from '../../../_models/generic-dialog-data.model';
import { MatButton, MatIconButton } from '@angular/material/button';

@Component({
	selector: 'common-generic-dialog',
	templateUrl: './generic-dialog.component.html',
	styleUrl: './generic-dialog.component.scss',
	imports: [MatIconModule, TranslateModule, MatDividerModule, MatDialogModule, MatButton, MatIconButton],
	standalone: true,
})
export class GenericDialogComponent {
	@Input() public dialogData: GenericDialogData | undefined;

	private readonly dialogRef = inject(MatDialogRef<GenericDialogComponent>);

	public onConfirm(): void {
		this.dialogRef.close(true);
	}

	public onCancel(): void {
		this.dialogRef.close(false);
	}
}
